export var welcomePageId = 'welcomePageWrapper';
/**
 * Chooses which popup to show
 * Important! This file is kept because we regularly need to
 * include a popup on the welcome page, for regular marketing surveys
 * */
var WelcomePage = function () { return null; };
export default WelcomePage;
